<template>
    <div>
        <Modal v-model="modal" :title="!elasticBlockStoreForm.id ? this.$t('alarms.disk.addDiskAlarm'):this.$t('alarms.disk.editDiskAlarm')" @on-cancel="cancel" @on-ok="ok"  :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="900px" :footer-hide="true" :closable="false">
            <Form ref="elasticBlockStoreForm" :model="elasticBlockStoreForm" :label-width="110" :rules="ruleValidate" >
                <!-- 下一步 -->
                <div v-show="isNext">
                    <!-- 微信警告 -->
                    <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
                    <!-- 规则名称 -->
                    <FormItem :label="$t('alarms.common.ruleName')" prop="ruleName" v-if="isEditRuleName">
                        <Row>
                            <Col span="11">
                                <Input type="text" v-model="elasticBlockStoreForm.ruleName" placeholder="Enter something..." style="width:300px;" :disabled="isEdit"></Input>
                            </Col>
                        </Row>
                    </FormItem>

                    <!-- 规则名称 -->
                    <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
                        <Row>
                            <Col span="24">
                                <div>{{this.elasticBlockStoreForm.ruleName}}</div>
                            </Col>
                        </Row>
                    </FormItem>

                    <!-- 规则描述 -->
                    <FormItem :label="$t('alarms.common.ruleDescription')">
                        <Row :gutter="4">
                            <!-- 监控指标 -->
                            <Col span="4">
                                <FormItem prop="monitorIndex">
                                    <Select v-model="elasticBlockStoreForm.monitorIndex" filterable @on-change="changeMonitorIndex(elasticBlockStoreForm.monitorIndex)" :placeholder="$t('alarms.common.pleaseSelect')">
                                        <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 周期 -->
                            <Col span="3">
                                <FormItem prop="cycle">
                                    <Select v-model="elasticBlockStoreForm.cycle" filterable :placeholder="$t('alarms.common.cycle')" @on-change="changeCycle(elasticBlockStoreForm.cycle)">
                                        <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 连续周期 -->
                            <Col span="4">
                                <FormItem prop="continousCycle">
                                    <Select v-model="elasticBlockStoreForm.continousCycle" filterable :placeholder="$t('alarms.common.continuousCycle')" @on-change="changeContinousCycle(elasticBlockStoreForm.continousCycle)">
                                        <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 统计数值 -->
                            <Col span="4">
                                <FormItem prop="statisticsValue">
                                    <Select v-model="elasticBlockStoreForm.statisticsValue" filterable :placeholder="$t('alarms.common.statisticsValue')" @on-change="changeStatisticsValue(elasticBlockStoreForm.statisticsValue)">
                                        <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>


                            <div v-if="this.isShowField!=1">
                                <!-- 关系符号 -->
                                <Col span="3">
                                    <FormItem prop="relationshipSign">
                                        <Select v-model="elasticBlockStoreForm.relationshipSign" filterable @on-change="changeRelationshipSign(elasticBlockStoreForm.relationshipSign)" :placeholder="$t('alarms.common.symbol')">
                                            <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">{{item.name}}</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <!-- 阈值 -->
                                <Col span="3" v-if="isNotIOPS">
                                    <FormItem prop="thresholdValue">
                                        <Input v-model="elasticBlockStoreForm.thresholdValue" :placeholder="$t('alarms.common.threshold')" type="number"></Input>
                                    </FormItem>
                                </Col>
                                <!-- 阈值 -->
                                <Col span="2" v-if="isIOPS">
                                  <div>{{ $t('alarms.common.standardValue') }}</div>
                                </Col>
                                <!-- 单位 -->
                                <Col span="2">
                                    <FormItem prop="unit">
                                        <Input v-model="elasticBlockStoreForm.unit" disabled :placeholder="$t('alarms.common.unit')"></Input>
                                    </FormItem>
                                </Col>
                            </div>
                            <div v-else-if="this.isShowField==2">
                                <!-- 关系符号 -->
                                <Col span="3">
                                    <FormItem prop="relationshipSign">
                                        <Select v-model="elasticBlockStoreForm.relationshipSign" filterable @on-change="changeRelationshipSign(elasticBlockStoreForm.relationshipSign)" :placeholder="$t('alarms.common.symbol')">
                                            <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">{{item.name}}</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <!-- 阈值 -->
                                <Col span="3" v-if="isNotIOPS">
                                    <FormItem prop="thresholdValue">
                                        <Input v-model="elasticBlockStoreForm.thresholdValue" :placeholder="$t('alarms.common.threshold')" type="number"></Input>
                                    </FormItem>
                                </Col>
                                <!-- 阈值 -->
                                <Col span="2" v-if="isIOPS">
                                  <div>{{ $t('alarms.common.standardValue') }}</div>
                                </Col>
                                <!-- 单位 -->
                                <Col span="2">
                                    <FormItem prop="unit">
                                        <Input v-model="elasticBlockStoreForm.unit" disabled :placeholder="$t('alarms.common.unit')"></Input>
                                    </FormItem>
                                </Col>
                            </div>

                        </Row>
                    </FormItem>

                    <!-- 审批流 -->
                    <FormItem :label="$t('alarms.common.approvalFlow')" prop="approvalFlow" v-if="elasticBlockStoreForm.monitorIndex==12">
                        <Select v-model="elasticBlockStoreForm.approvalFlow" style="width:300px;" :transfer="true" :placeholder="$t('alarms.common.pleaseSelect')">
                            <Option :value="item.id" v-for="(item,index) in approvalFlowList" v-bind:key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>

                    <!-- 联系方式 -->
                    <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
                        <RadioGroup v-model="elasticBlockStoreForm.contactType" @on-change="changeContactType(elasticBlockStoreForm.contactType)">
                            <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
                        </RadioGroup>
                    </FormItem>

                    <!-- 通知对象 -->
                    <FormItem :label="$t('alarms.common.notificationObject')" prop="notificationObject" v-if="elasticBlockStoreForm.contactType==0">
                        <Select v-model="elasticBlockStoreForm.notificationObject" multiple style="width:300px;" @on-change="changeNotificationObject" :placeholder="$t('alarms.common.pleaseSelect')">
                            <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>

                    <!-- 联系人组 -->
                    <FormItem :label="$t('alarms.common.contactGroup')" prop="contactGroupIds" v-if="elasticBlockStoreForm.contactType==1">
                        <Select v-model="elasticBlockStoreForm.contactGroupIds" multiple style="width:300px;" @on-change="changeContactGroupId(elasticBlockStoreForm.contactGroupIds)" :placeholder="$t('alarms.common.pleaseSelect')">
                            <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>

                    <!-- 报警方式 -->
                    <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
                      <Select v-model="elasticBlockStoreForm.noticeType" multiple style="width:300px;" @on-change="selectnoticeType(elasticBlockStoreForm.noticeType)" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
                    </FormItem>

                    <!-- 企业微信机器人URL -->
                    <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="elasticBlockStoreForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
                        <Select v-model="elasticBlockStoreForm.enterpriseWechatRobotIds" multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
                            <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>

                    <!-- 延迟告警 -->
                    <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
                        <Select v-model="elasticBlockStoreForm.alarmDelay" style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
                          <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>

                    <!-- 监控时段 -->
                    <FormItem :label="$t('alarms.common.monitorPeriod')" prop="monitorPeriod">
                      <Select v-model="elasticBlockStoreForm.monitorPeriod" style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in monitorPeriodList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
                    </FormItem>

                    <!-- AI是否接管 -->
                    <FormItem :label="$t('alarms.common.aiIntervention')">
                        <i-switch
                          size="large"
                          :true-value="1"
                          :false-value="0"
                          v-model="elasticBlockStoreForm.aiInterventionEnabled"
                        >
                            <span slot="open">{{ $t('alarms.common.aiInterventionYes') }}</span>
                            <span slot="close">{{ $t('alarms.common.aiInterventionNo') }}</span>
                        </i-switch>
                    </FormItem>

                    <!-- 邮箱模板 -->
                    <div v-show="isShowEmail">
                        <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
                            <Input v-model="elasticBlockStoreForm.emailModal" type="textarea" :autosize="{minRows: 2,maxRows: 5}"  style="width:665px;" disabled></Input>
                        </FormItem>
                    </div>

                    <!-- 企业微信模板 -->
                    <div v-show="isShowWeChat">
                        <FormItem :label="$t('alarms.common.wechatModal')" prop="wechatModal">
                            <Input v-model="elasticBlockStoreForm.wechatModal" type="textarea" :autosize="{minRows: 2,maxRows: 5}"  style="width:665px;" disabled></Input>
                        </FormItem>
                    </div>
                    <div style="height: 42px;">
                        <Button type="primary" size="large" style="float: right;"  @click="ok('elasticBlockStoreForm')" :loading="addloading"  :disabled="isAddOrEdit">{{!elasticBlockStoreForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}</Button>
                        <Button size="large"  style="float: right;margin-right: 10px;" @click="cancel('elasticBlockStoreForm')">{{ $t('alarms.common.cancel') }}</Button>
                        <Button size="large" @click="previousPage" style="float: right;margin-right: 10px;">{{ $t('alarms.common.lastStep') }}</Button>
                    </div>
                </div>

                <!-- 上一步 -->
                <div v-show="isPrevious">
                    <div>
                        <Row :gutter="16">
                            <Col span="8">
                                <!-- 账户 -->
                                <FormItem :label="$t('alarms.common.account')" prop="account" :label-width="70">
                                    <Select v-model="elasticBlockStoreForm.account" @on-change="changeAccount(elasticBlockStoreForm.account)" :transfer="true" :placeholder="$t('alarms.common.pleaseSelect')">
                                        <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col span="8" style="z-index: 200">
                                <!-- 存储区域 -->
                                <FormItem :label="$t('alarms.common.region')" prop="backupRegion">
                                    <Select @on-change="changebackupRegion(elasticBlockStoreForm.backupRegion)" v-model="elasticBlockStoreForm.backupRegion" multiple :max-tag-count="1" :transfer="true" :placeholder="$t('alarms.common.pleaseSelect')">
                                        <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('alarms.common.allSelected') }}</Checkbox>
                                        <Option  :value="item.name" v-for="item in backupRegionList" :key="item.id">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col span="6">
                                <!-- 标签 -->
                                <FormItem :label="$t('alarms.common.tags')" prop="tags"  :label-width="50">
                                    <Input  v-model="elasticBlockStoreForm.tags" :placeholder="$t('alarms.common.pleaseInputValue')" />
                                </FormItem>
                            </Col>
                            <Button type="primary" style="float: right;" v-show="isShowSearch" @click="searchEBSDate">{{ $t('alarms.common.search') }}</Button>
                        </Row>
                    </div>

                    <v-table :height="459" column-width-drag is-horizontal-resize style="width:100%;height:459px;margin-bottom: 15px;" :columns="column" :table-data="tableEBSDate" row-hover-color="#edf7ff" :is-loading="modal_loadings" title-bg-color="#f8f8f9" :select-group-change="selectChange" :select-all="selectAll"></v-table>
                    <div style="height: 42px;">
                        <Button type="primary" size="large" @click="nextPage" style="float: right;" :disabled="isNextClick">{{ $t('alarms.common.nextStep') }}</Button>
                        <Button size="large"  style="margin-right: 10px;float: right;" @click="cancel('elasticBlockStoreForm')">{{ $t('alarms.common.cancel') }}</Button>
                    </div>
                </div>
            </Form>
        </Modal>
    </div>
</template>
<script>
    import WechatWarning from '../common/WechatWarning.vue'
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    import TableElasticBlockStore from '../ebs/TableElasticBlockStore.vue'
    var tableElasticBlockStore = TableElasticBlockStore;
    var tableEBSWarningVue = {}
    export default {
        inject:['reload'],
        components: {
            WechatWarning
        },
        data () {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) =>{
                var self = this;
                self.$api.alertRule.nameRepeatedCheck({
                    "alertRuleName": this.elasticBlockStoreForm.ruleName,
                    "monitorModule": this.monitorModule
                })
                .then(res => {
                    if(res.status==200){
                        callback();
                    }
                })
                .catch(err =>{
                    if(err.status==400){
                        callback(new Error(this.$t('monitor.ebs.warning.rule.ruleNameDuplicate')));
                    }
                })
            };
            return {
                monitorModule:11,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                    label: this.$t('alarms.common.contactPerson'),
                    value: 'contact',
                    type: 0
                },
                {
                    label: this.$t('alarms.common.contactGroup'),
                    value: 'contactGroup',
                    type: 1
                }],
                addloading:false,
                singleBackupRegion:false,
                alarmDelayList:[],
              monitorPeriodList:[],
                isShowField:'', //是否显示符号、阈值和单位
                isNotIOPS:true,
                isIOPS:false,
                isEdit:false,
                isShowSearch:false,
                isEditRuleName:false,
                showRuleName:false,
                modal_loadings: false,
                isShowEmail:false,
                isShowWeChat:false,
                isNext:false,
                isPrevious:true,
                alarmWayList: [],
                selection:[],
                accountList: [],
                notificationObjectList: [],
                backupRegionList:[],
                loading: true,
                modal:false,
                modal_loading: false,
                exportDataList:'',
                noticeType:[],
                isNextClick:true, //禁止点击下一步
                unit:'',
                units:'',
                approvalFlowList:[],
                elasticBlockStoreForm: {
                    account:'',
                    ruleName: '',
                    notificationObject: [],
                    noticeType:[],
                    emailModal:'',
                    wechatModal:'',
                    thresholdValue:'',
                    monitorIndex:'',
                    cycle:'',
                    continousCycle:'',
                    statisticsValue:'',
                    relationshipSign:'',
                    unit:'',
                    backupRegion:[],
                    tags:'',
                    alarmDelay:'',
                    monitorPeriod:'',
                    contactType:0,
                    contactGroupIds:[],
                    userIdList:[],
                    approvalFlow:'',
                    enterpriseWechatRobotIds:[],
                    aiInterventionEnabled: 1
                },
                enterpriseWechatRobotIdsList:[],
                // 联系人组
                contactGroupIdList:[],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        { required: true, message: this.$t('monitor.ebs.warning.rule.account'), trigger: 'change',type:'number' }
                    ],
                    alarmDelay: [
                        {required: true, message: this.$t('monitor.ebs.warning.rule.alarmDelay'), trigger: 'change', type: 'number'}
                    ],
                  monitorPeriod: [
                    {required: true, message: this.$t('monitor.ebs.warning.rule.monitorPeriod'), trigger: 'change', type: 'number'}
                  ],
                    backupRegion: [
                        { required: true, message: this.$t('monitor.ebs.warning.rule.backupRegion'), trigger: 'change',type: 'array'}
                    ],
                    ruleName: [
                        { required: true, message: this.$t('monitor.ebs.warning.rule.ruleNameRequired'), trigger: 'blur' },
                        { type: 'string', message: this.$t('monitor.ebs.warning.rule.ruleNamePattern'), pattern:'^[^ ]{2,20}$', trigger: 'blur'},
                        { validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        { required: true, type: 'array',message: this.$t('monitor.ebs.warning.rule.notificationObject')}
                    ],
                    noticeType: [
                        { required: true, type: 'array', min: 1, message: this.$t('monitor.ebs.warning.rule.noticeType'), trigger: 'change' }
                    ],
                    monitorIndex: [
                        { required: true, message: this.$t('monitor.ebs.warning.rule.monitorIndex'), trigger: 'change',type:'number' }
                    ],
                    cycle: [
                        { required: true, message: this.$t('monitor.ebs.warning.rule.cycle'), trigger: 'change',type:'number' }
                    ],
                    continousCycle: [
                        { required: true, message: this.$t('monitor.ebs.warning.rule.continousCycle'), trigger: 'change',type:'number' }
                    ],
                    statisticsValue: [
                        { required: true, message: this.$t('monitor.ebs.warning.rule.statisticsValue'), trigger: 'change',type:'number' }
                    ],
                    relationshipSign: [
                        { required: true, message: this.$t('monitor.ebs.warning.rule.relationshipSign'), trigger: 'change',type:'number' }
                    ],
                    thresholdValue: [
                        { required: true, message: this.$t('monitor.ebs.warning.rule.thresholdValue')}
                    ],
                    contactType: [
                        {required: true, message: this.$t('monitor.ebs.warning.rule.contactType'), trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: this.$t('monitor.ebs.warning.rule.contactGroupIds'), trigger: 'change', type: 'array'}
                    ],
                    approvalFlow: [
                        { required: true, message: this.$t('monitor.ebs.warning.rule.approvalFlow'), trigger: 'change', type: 'number' }
                    ],
                    enterpriseWechatRobotIds: [
                        {required: true, type: 'array', message: this.$t('monitor.ebs.warning.rule.enterpriseWechatRobotIds'), trigger: 'change'}
                    ]
                },
                column: [
                    {   width: 60,
                        titleAlign: 'center',
                        columnAlign:'center',
                        type: 'selection'
                    },
                    {
                        title: this.$t('alarms.disk.name'),
                        field: 'name',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        title: this.$t('alarms.instance.instanceId'),
                        field: 'instanceId',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        title: this.$t('alarms.disk.deviceName'),
                        field: 'deviceName',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        title: this.$t('alarms.disk.diskId'),
                        field: 'volumeAwsId',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        title: this.$t('alarms.disk.capacity'),
                        field: 'capacity',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        title: this.$t('alarms.disk.type'),
                        field: 'type',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        title: this.$t('alarms.disk.iops'),
                        field: 'iops',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        title: this.$t('alarms.disk.encrypted'),
                        field: 'encrypted',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        title: this.$t('alarms.disk.region'),
                        field: 'region',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        title: this.$t('alarms.disk.state'),
                        field: 'stateName',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    }
                ],
                tableEBSDate:[],
                newTableEBSDateList:[],
                volumeList:[],
                compareVolumeList:[]
            }
        },

        beforeCreate: function () {
            tableEBSWarningVue = this
        },
        methods:{
            // 下一步
            nextPage: function(){
                this.isNext=true;
                this.isPrevious=false;
                 // 查询监控指标
                tableEBSWarningVue.searchMonitorIndex();
                // 查询阈值
                tableEBSWarningVue.selectMonitorIndexDefault();
                // 查询联系人组
                tableEBSWarningVue.listContactGroups();
            },
            // 上一步
            previousPage: function(){
                this.isNext=false;
                this.isPrevious=true;
            },
            init: function(id){
                this.elasticBlockStoreForm.id = id || 0;
                // 根据用户名查询Account列表
                tableEBSWarningVue.getAccount();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['elasticBlockStoreForm'].resetFields();
                    if(this.elasticBlockStoreForm.id){
                        // 编辑显示不能输入的规则名称
                        this.showRuleName=true;
                        this.isEdit=true;
                        this.isShowSearch=false;
                        // 根据ID查询报警规则
                        /****************************************************************/
                        this.$api.alertRule.selectAlertRule("id",this.elasticBlockStoreForm.id)
                        .then(res => {
                            //延时
                            this.elasticBlockStoreForm.alarmDelay = res.data.delay;
                            //监控时段
                            this.elasticBlockStoreForm.monitorPeriod = res.data.monitorPeriod;
                            // AI是否接管
                            this.elasticBlockStoreForm.aiInterventionEnabled = res.data.aiInterventionEnabled === 0 ? 0 : 1;
                            // 账户
                            /******************************************************/
                            this.elasticBlockStoreForm.account=res.data.accountId;
                            tableEBSWarningVue.$api.account.queryAccountRegions("accountId",this.elasticBlockStoreForm.account)
                            .then(res => {
                                this.backupRegionList = res.data;
                            });
                            // 查询通知对象
                          tableEBSWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                            "monitorModule":this.monitorModule,
                            "accountId":this.elasticBlockStoreForm.account
                          })
                            .then(res => {
                              this.notificationObjectList = res.data.contactList;
                            });
                            this.modal_loadings = true;
                            setTimeout(() => {
                                // 存储区域
                                this.elasticBlockStoreForm.backupRegion=res.data.regions;

                                // 实例列表
                                /******************************************************/
                                this.volumeList=res.data.volumeList;
                                this.compareVolumeList=res.data.volumeList;

                                // 根据AccountId查询卷列表
                                tableEBSWarningVue.$api.groupVolumeRelation.queryVolumeByGroup({
                                    "regions": this.elasticBlockStoreForm.backupRegion,
                                    "accountId": this.elasticBlockStoreForm.account
                                })
                                .then(res => {
                                    this.tableEBSDate=res.data;
                                    this.modal_loadings = false;
                                    for(var i=0;i<this.tableEBSDate.length;i++){
                                        for(var j=0;j<this.compareVolumeList.length;j++){
                                            if(this.tableEBSDate[i].volumeAwsId==this.compareVolumeList[j].volumeAwsId){
                                                this.tableEBSDate[i]._checked=true;
                                            }
                                        }
                                    }
                                    // 选了数据 可以点击下一步
                                    if(this.tableEBSDate.length==0||this.compareVolumeList.length==0){
                                        this.isNextClick=true;
                                    }else{
                                        this.isNextClick=false;
                                    }
                                })
                            }, 1000)

                            this.newTableEBSDateList=res.data.volumeList;



                            // 规则名称
                            this.elasticBlockStoreForm.ruleName=res.data.alertRuleName;

                            // 监控指标
                            /******************************************************/
                            this.elasticBlockStoreForm.monitorIndex=res.data.monitorIndex;
                            // 如果监控指标为实例健康状态或者系统健康状态或者实例维护信息时 不显示符号、阈值和单位
                            if(this.elasticBlockStoreForm.monitorIndex==32){
                                this.isShowField=1;
                            }else{
                                this.isShowField=2;
                            }

                            // get company id
                            tableEBSWarningVue.$api.account.getCompanyIdByAccountId("accountId", this.elasticBlockStoreForm.account)
                                .then(res => {
                                    let companyId = res.data;
                                    // 审批流
                                    tableEBSWarningVue.$api.processTemplate.listProcessTemplatesByMetricIndexAndCompanyId({
                                        'metricIndex' :this.elasticBlockStoreForm.monitorIndex,
                                        'companyId': companyId
                                    })
                                        .then(res => {
                                            this.approvalFlowList=res.data;
                                        })
                                })
                            this.elasticBlockStoreForm.approvalFlow=parseInt(res.data.processTemplateId);

                            // 如果监控指标为磁盘读取IOPS标准值时 不显示阈值
                            if(this.elasticBlockStoreForm.monitorIndex==34){
                                this.isIOPS=true;
                                this.isNotIOPS=false;
                            }else{
                                this.isNotIOPS=true;
                                this.isIOPS=false;
                            }
                            // 周期
                            this.elasticBlockStoreForm.cycle=res.data.cycle;
                            // 连续周期
                            this.elasticBlockStoreForm.continousCycle=res.data.continousCycle;
                            // 统计数值
                            this.elasticBlockStoreForm.statisticsValue=res.data.statisticsValue;
                            // 符号
                            this.elasticBlockStoreForm.relationshipSign=res.data.relationshipSign;
                            // 阈值
                            this.elasticBlockStoreForm.thresholdValue=res.data.thresholdValue;
                            // 单位
                            this.elasticBlockStoreForm.unit=res.data.unit;
                            this.units=res.data.unitId;
                            // 企业微信机器人URL
                            this.elasticBlockStoreForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                            // 联系方式
                            this.elasticBlockStoreForm.contactType = res.data.contactType;
                            if(res.data.contactType==0){
                                // 通知对象
                                this.elasticBlockStoreForm.notificationObject=res.data.contactIDs;
                                for(var i=0;i<this.elasticBlockStoreForm.notificationObject.length;i++){
                                    for(var j=0;j<this.notificationObjectList.length;j++){
                                        if(this.elasticBlockStoreForm.notificationObject[i]==this.notificationObjectList[j].id){
                                            this.elasticBlockStoreForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                        }
                                    }
                                }
                            }else if(res.data.contactType==1){
                                // 联系人组
                                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.elasticBlockStoreForm.account)
                                .then(res => {
                                    this.contactGroupIdList = res.data;
                                })
                                setTimeout(() => {
                                    this.elasticBlockStoreForm.contactGroupIds = res.data.contactGroupIds;
                                }, 1000)
                            }

                            // 报警方式
                            this.elasticBlockStoreForm.noticeType = res.data.noticeType;

                            for (var i = 0; i < this.elasticBlockStoreForm.noticeType.length; i++){

                            if (this.elasticBlockStoreForm.noticeType[i] == '0') {
                              this.isShowEmail = true;
                              this.elasticBlockStoreForm.emailModal = res.data.briefReportBodyMail;
                              this.noticeType = this.elasticBlockStoreForm.noticeType;
                              tableEBSWarningVue.selectTemplate();
                            }
                            if (this.elasticBlockStoreForm.noticeType[i] == '1') {
                              // this.isShowWeChat = true;
                              this.elasticBlockStoreForm.wechatModal = res.data.briefReportBodyWechat;
                              this.checkLeastOnePersonBoundWeChat();
                              this.noticeType = this.elasticBlockStoreForm.noticeType;
                              tableEBSWarningVue.selectTemplate();
                            }else if(this.elasticBlockStoreForm.noticeType[i]!='1'){
                                this.wechatWarningVisible=false;
                                this.isAddOrEdit=false;
                            }

                          }

                        })
                    }else{
                        this.tableEBSDate=[];
                        this.isEdit=false;
                        this.isShowSearch=true;
                        // 添加显示规则名称能输入
                        this.isEditRuleName=true;
                        this.showRuleName=false;
                    }
                })
                this.modal=true;
                this.isNext=false;
                this.isPrevious=true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function(){
                this.elasticBlockStoreForm.cycle='';
                this.elasticBlockStoreForm.continousCycle='';
                this.elasticBlockStoreForm.statisticsValue='';
                this.elasticBlockStoreForm.relationshipSign='';
                this.elasticBlockStoreForm.thresholdValue='';
            },
            isNotEmpty: function (obj){
                if(typeof obj === "undefined" || obj === null || obj === "")
                {
                    return false;
                }else{
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function(){
                 // 如果监控指标为实例健康状态或者系统健康状态或者实例维护信息时 不显示符号、阈值和单位
                if(this.elasticBlockStoreForm.monitorIndex==32){
                    this.isShowField=1;
                }else{
                    this.isShowField=2;
                }

                // 如果监控指标为磁盘读取IOPS标准值时 不显示阈值
                if(this.elasticBlockStoreForm.monitorIndex==34){
                    this.isIOPS=true;
                    this.isNotIOPS=false;
                }else{
                    this.isNotIOPS=true;
                    this.isIOPS=false;
                }
                tableEBSWarningVue.selectMonitorIndexDefault();
                this.unit=this.elasticBlockStoreForm.monitorIndex;
                for(var i=0;i<this.monitorIndexList.length;i++){
                    if(this.monitorIndexList[i].id==this.unit){
                        this.elasticBlockStoreForm.unit=this.monitorIndexList[i].unit;
                        this.units=this.monitorIndexList[i].id;
                    }
                }
                tableEBSWarningVue.selectTemplate();
                tableEBSWarningVue.emptyDate();
                tableEBSWarningVue.listProcessTemplatesByMetricIndex();
            },
            // 新增时，查询审批流列表
            listProcessTemplatesByMetricIndex:function(){

                if(this.elasticBlockStoreForm.monitorIndex==undefined){
                    return;
                }

                tableEBSWarningVue.$api.account.getCompanyIdByAccountId("accountId", this.elasticBlockStoreForm.account)
                    .then(res => {
                        let companyId = res.data;
                        // 审批流
                        tableEBSWarningVue.$api.processTemplate.listProcessTemplatesByMetricIndexAndCompanyId({
                            'metricIndex' :this.elasticBlockStoreForm.monitorIndex,
                            'companyId': companyId
                        })
                            .then(res => {
                                this.approvalFlowList=res.data;
                            })
                    })
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function(){
                if(this.elasticBlockStoreForm.account==""||this.elasticBlockStoreForm.account==null){
                    return;
                }
                tableEBSWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.elasticBlockStoreForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle":this.elasticBlockStoreForm.cycle,
                    "continousCycle":this.elasticBlockStoreForm.continousCycle,
                    "statisticsValue":this.elasticBlockStoreForm.statisticsValue,
                    "relationshipSign":this.elasticBlockStoreForm.relationshipSign,
                    "accountId": this.elasticBlockStoreForm.account
                })
                .then(res => {
                    // 周期
                    this.cycleList=res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList=res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList=res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList=res.data.relationshipSignMap;
                    // 阈值
                    if(res.data.companyMonitoritemVariablesList.length==1&&tableEBSWarningVue.isNotEmpty(this.elasticBlockStoreForm.cycle)&&tableEBSWarningVue.isNotEmpty(this.elasticBlockStoreForm.continousCycle)&&tableEBSWarningVue.isNotEmpty(this.elasticBlockStoreForm.statisticsValue)&&tableEBSWarningVue.isNotEmpty(this.elasticBlockStoreForm.relationshipSign)&&this.elasticBlockStoreForm.id==0){
                        this.elasticBlockStoreForm.thresholdValue=res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
                    }
                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function(){
                tableEBSWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.elasticBlockStoreForm.monitorIndex,
                    "relationshipSign":this.elasticBlockStoreForm.relationshipSign,
                    "monitorModule": this.monitorModule,
                    "noticeType":this.elasticBlockStoreForm.noticeType
                })
                .then(res => {
                    this.elasticBlockStoreForm.wechatModal=res.data.briefReportBodyWechat;
                    this.elasticBlockStoreForm.emailModal=res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectnoticeType: function(){
              this.isShowEmail = false;
              this.isShowWeChat = false;
              for(var i=0;i<this.elasticBlockStoreForm.noticeType.length;i++) {
                if (this.elasticBlockStoreForm.noticeType[i] == '0') {
                  this.isShowEmail = true;
                  this.noticeType = this.elasticBlockStoreForm.noticeType;
                  tableEBSWarningVue.selectTemplate();
                }
                if (this.elasticBlockStoreForm.noticeType[i] == '1') {
                    // this.isShowWeChat = true;
                    this.noticeType = this.elasticBlockStoreForm.noticeType;
                    this.checkLeastOnePersonBoundWeChat();
                    tableEBSWarningVue.selectTemplate();
                }else if(this.elasticBlockStoreForm.noticeType[i]!='1'){
                    this.wechatWarningVisible=false;
                    this.isAddOrEdit=false;
                }
              }
            },
            // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
              for(var i=0;i<this.elasticBlockStoreForm.noticeType.length;i++){
                  if(this.elasticBlockStoreForm.noticeType[i]==1){
                      var weChatDate={
                          "contactType":this.elasticBlockStoreForm.contactType
                      };
                      // 联系方式为 -联系人-
                      if(this.elasticBlockStoreForm.contactType==0){
                          weChatDate.userIds=this.elasticBlockStoreForm.userIdList;
                      }
                      // 联系方式为 -联系人组-
                      else if(this.elasticBlockStoreForm.contactType==1){
                          weChatDate.contactGroupIds = this.elasticBlockStoreForm.contactGroupIds;
                      }
                      this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                      .then(res => {
                          if(res.data){
                            // 可以添加告警
                            this.wechatWarningVisible=false;
                            this.isAddOrEdit=false;
                          }else{
                            // 不可以添加微信告警
                            this.wechatWarningVisible=true;
                            this.isAddOrEdit=true;
                          }
                      })
                  }else if(this.elasticBlockStoreForm.noticeType[i]!=1){
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                  }
              }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.elasticBlockStoreForm.account)
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
               this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
                this.elasticBlockStoreForm.userIdList=[];
                this.elasticBlockStoreForm.notificationObject=val;
                for(var i=0;i<this.elasticBlockStoreForm.notificationObject.length;i++){
                    for(var j=0;j<this.notificationObjectList.length;j++){
                        if(this.elasticBlockStoreForm.notificationObject[i]==this.notificationObjectList[j].id){
                            this.elasticBlockStoreForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                        }
                    }
                }
                this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
              this.checkLeastOnePersonBoundWeChat();
            },
            //点击查询 加载全部数据
            /***********************************************************************************/
            searchEBSDate: function(){
                if(this.elasticBlockStoreForm.account==""||this.elasticBlockStoreForm.account==null||this.elasticBlockStoreForm.backupRegion==""||this.elasticBlockStoreForm.backupRegion==null){
                    return;
                }
                this.modal_loadings = true;
                // 根据AccountId查询卷列表
                tableEBSWarningVue.$api.groupVolumeRelation.queryVolumeByGroup({
                    "regions": this.elasticBlockStoreForm.backupRegion,
                    "accountId": this.elasticBlockStoreForm.account,
                    "tags": this.elasticBlockStoreForm.tags
                })
                .then(res => {
                    this.tableEBSDate=res.data;
                    this.modal_loadings = false;
                })
            },

            /**************************************  查询  **************************************/
            // 查询监控指标
            searchMonitorIndex: function(){
                tableEBSWarningVue.$api.alertRule.searchMonitorIndex({
                  "monitorModule":this.monitorModule,
                  "accountId":this.elasticBlockStoreForm.account
                })
                .then(res => {
                    this.monitorIndexList = res.data;
                })
            },
            // 查询通知对象
            queryContacts: function(){
                tableEBSWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                  "monitorModule":this.monitorModule,
                  "accountId":this.elasticBlockStoreForm.account
                })
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.elasticBlockStoreForm.notificationObject=res.data.defaultContactIds;
                })
            },
            // 查询报警方式
            alarmWay: function () {
                tableEBSWarningVue.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
                  .then(res => {
                    this.alarmWayList = res.data;
                  })
            },
           // 查询报警延迟
            getAlarmDelay: function () {
                tableEBSWarningVue.$api.alertRule.alarmDelay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmDelayList = res.data;
              })
            },
          // 查询监控时间段
          searchMonitorPeriod: function(){
            this.$api.alertRule.monitorPeriod("userName",getCookie(global.cookieName))
              .then(res => {
                this.monitorPeriodList = res.data;
              })
          },
            // 周期
            changeCycle: function(){
                // 查询阈值
                tableEBSWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function(){
                // 查询阈值
                tableEBSWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function(){
                // 查询阈值
                tableEBSWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function(){
                // 查询阈值
                tableEBSWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableEBSWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            getAccount: function(){
                // 清空表格
                this.tableEBSDate=[];
                tableEBSWarningVue.$api.account.queryAccounts("userName",getCookie(global.cookieName))
                .then(res => {
                    this.accountList = res.data;
                    for(var i=0;i<this.accountList.length;i++){
                        this.accountList[i].name=this.accountList[i].name+'('+this.accountList[i].accountTypeName+')';
                    }
                })
                // 查询方式
                tableEBSWarningVue.alarmWay();
                // 查询报警延时
                tableEBSWarningVue.getAlarmDelay();
                //监控时段
                tableEBSWarningVue.searchMonitorPeriod();
            },
            // 选择账户
            changeAccount: function(){
                if(this.elasticBlockStoreForm.account==""||this.elasticBlockStoreForm.account==null){
                    return;
                }
                // 表格数据为空、显示查询按钮、存储区域为空
                this.tableEBSDate=[];
                this.volumeList=[];
                this.isShowSearch=true;
                this.isNextClick=true;
                this.elasticBlockStoreForm.backupRegion='';
                tableEBSWarningVue.$api.account.queryAccountRegions("accountId",this.elasticBlockStoreForm.account)
                .then(res => {
                    this.backupRegionList = res.data;
                });
                // 查询通知对象
                tableEBSWarningVue.queryContacts();
                // 查询联系人组
                tableEBSWarningVue.listContactGroups();
                // 监控模块查询关联的机器人列表
                tableEBSWarningVue.listEnterpriseWechatRobotsByMonitorModule();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableEBSWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                    "monitorModule":this.monitorModule
                })
                .then(res => {
                    this.enterpriseWechatRobotIdsList = res.data;
                })
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.elasticBlockStoreForm.backupRegion = []
                if (this.singleBackupRegion) {
                    this.backupRegionList.map((item) => {
                        this.elasticBlockStoreForm.backupRegion.push(item.name)
                    })
                } else {
                    this.elasticBlockStoreForm.backupRegion = []
                }
            },
            // 切换存储区域
            changebackupRegion: function(val){
                if (val.length === this.backupRegionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
                this.tableEBSDate=[];
                this.volumeList=[];
                this.isShowSearch=true;
                this.isNextClick=true;
            },
            // 全选 反选
            /***********************************************************************************/

            // 单选
            selectChange(selection){
                // 所有数据
                this.selection=selection;
                // 清空数组
                this.newTableEBSDateList=[];
                for(var i=0;i<this.selection.length;i++){
                    var TableEBSCopy=new Object();
                    TableEBSCopy.awsZone=this.selection[i].awsZone;
                    TableEBSCopy.instanceId=this.selection[i].instanceId;
                    TableEBSCopy.deviceName=this.selection[i].deviceName;
                    TableEBSCopy.capacity=this.selection[i].capacity;
                    TableEBSCopy.encrypted=this.selection[i].encrypted;
                    TableEBSCopy.state=this.selection[i].state;
                    TableEBSCopy.iops=this.selection[i].iops;
                    TableEBSCopy.name=this.selection[i].name;
                    TableEBSCopy.region=this.selection[i].region;
                    TableEBSCopy.type=this.selection[i].type;
                    TableEBSCopy.volumeAwsId=this.selection[i].volumeAwsId;
                    TableEBSCopy.accountId=this.selection[i].accountId;
                    this.newTableEBSDateList.push(TableEBSCopy);
                }
                // 选了数据 可以点击下一步
                if(this.newTableEBSDateList.length==0){
                    this.isNextClick=true;
                }else{
                    this.isNextClick=false;
                }
            },
            // 全选
            selectAll(selection){
                // 所有数据
                this.selection=selection;
                // 清空数组
                this.newTableEBSDateList=[];
                for(var i=0;i<this.selection.length;i++){
                    var TableEBSCopy=new Object();
                    TableEBSCopy.awsZone=this.selection[i].awsZone;
                    TableEBSCopy.instanceId=this.selection[i].instanceId;
                    TableEBSCopy.deviceName=this.selection[i].deviceName;
                    TableEBSCopy.capacity=this.selection[i].capacity;
                    TableEBSCopy.encrypted=this.selection[i].encrypted;
                    TableEBSCopy.state=this.selection[i].state;
                    TableEBSCopy.iops=this.selection[i].iops;
                    TableEBSCopy.name=this.selection[i].name;
                    TableEBSCopy.region=this.selection[i].region;
                    TableEBSCopy.type=this.selection[i].type;
                    TableEBSCopy.volumeAwsId=this.selection[i].volumeAwsId;
                    TableEBSCopy.accountId=this.selection[i].accountId;
                    this.newTableEBSDateList.push(TableEBSCopy);
                }
                // 选了数据 可以点击下一步
                if(this.selection.length==0){
                    this.isNextClick=true;
                }else{
                    this.isNextClick=false;
                }
            },
            // 创建报警
            /**********************************************************************************/
            ok: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        var alertList={
                            "alertRuleName": this.elasticBlockStoreForm.ruleName,
                            "monitorIndex": this.elasticBlockStoreForm.monitorIndex,
                            "cycle": this.elasticBlockStoreForm.cycle,
                            "continousCycle": this.elasticBlockStoreForm.continousCycle,
                            "statisticsValue": this.elasticBlockStoreForm.statisticsValue,
                            "relationshipSign": this.elasticBlockStoreForm.relationshipSign,
                            "thresholdValue": this.elasticBlockStoreForm.thresholdValue,
                            "accountId": this.elasticBlockStoreForm.account,
                            "monitorModule": this.monitorModule,
                            "noticeType": this.elasticBlockStoreForm.noticeType,
                            "volumeDTOList": this.newTableEBSDateList,
                            "unit": this.units,
                            "delay":this.elasticBlockStoreForm.alarmDelay,
                            "monitorPeriod":this.elasticBlockStoreForm.monitorPeriod,
                            "contactType":this.elasticBlockStoreForm.contactType,
                            "enterpriseWechatRobotIds":this.elasticBlockStoreForm.enterpriseWechatRobotIds,
                            "aiInterventionEnabled":this.elasticBlockStoreForm.aiInterventionEnabled
                        };

                        // 如果联系方式是联系人 传通知对象
                        if(this.elasticBlockStoreForm.contactType == 0){
                            alertList.contactIDs = this.elasticBlockStoreForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.elasticBlockStoreForm.contactType == 1){
                            alertList.contactGroupIds = this.elasticBlockStoreForm.contactGroupIds;
                        }

                        // 如果监控指标为 没有EBS attached 传审批流
                        if(this.elasticBlockStoreForm.monitorIndex==12){
                            alertList.processTemplateId=this.elasticBlockStoreForm.approvalFlow;
                        }


                        if(this.elasticBlockStoreForm.id>0){
                            alertList.id=this.elasticBlockStoreForm.id;
                            alertList.volumeDTOList=this.newTableEBSDateList;
                            // 编辑告警
                            this.addloading=true;
                            tableEBSWarningVue.$api.alertRule.updateAlertRule(alertList)
                            .then(res => {
                                this.data = res.data;
                                setTimeout(() => {
                                    this.reload();
                                    tableElasticBlockStore.methods.showAll();
                                    this.elasticBlockStoreForm.notificationObject=[];
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$emit('on-ok',this.form);
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success(this.$t('common.editSuccess'));
                                    // 禁止点击下一步
                                    this.isNextClick=true;
                                    this.isShowSearch=false;
                                    this.isShowEmail = false;
                                    this.isShowWeChat = false;
                                    this.addloading=false;
                                    this.modal = false;
                                    this.wechatWarningVisible=false;
                                    this.isAddOrEdit=true;
                                },1000);
                            })
                        }else{
                            // 添加告警
                            this.addloading=true;
                            alertList.volumeDTOList=this.newTableEBSDateList;
                            tableEBSWarningVue.$api.alertRule.createAlertRule(alertList)
                            .then(res => {
                                this.data = res.data;
                                setTimeout(() => {
                                    this.reload();
                                    tableElasticBlockStore.methods.showAll();
                                    this.elasticBlockStoreForm.notificationObject=[];
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$emit('on-ok',this.form);
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success(this.$t('common.addSuccess'));
                                    // 禁止点击下一步
                                    this.isNextClick=true;
                                    this.isShowEmail = false;
                                    this.isShowWeChat = false;
                                    this.addloading=false;
                                    this.modal = false;
                                    this.wechatWarningVisible=false;
                                    this.isAddOrEdit=true;
                                },1000);
                            })
                        }

                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if(this.elasticBlockStoreForm.id>0){
                            this.$Message.error(this.$t('common.editFail'));
                        }else{
                            this.$Message.error(this.$t('common.addFail'));
                        }
                    }
                });
            },
            // 取消
            cancel: function(name){
                this.isAddOrEdit=true;
                this.wechatWarningVisible=false;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.isNextClick=true;
                this.modal=false;
                this.$emit('on-cancel');
                this.elasticBlockStoreForm.notificationObject=[];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                // 清空表格
                this.tableEBSDate=[];
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/ebs/AddOrUpdateElasticBlockStoreWarning.vue